import { render, staticRenderFns } from "./heduibiao.vue?vue&type=template&id=c03bc67c&scoped=true&"
import script from "./heduibiao.vue?vue&type=script&lang=js&"
export * from "./heduibiao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03bc67c",
  null
  
)

export default component.exports